import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ModelBase } from 'store/model-base';
import { ApiChannel } from 'core/constants';
import { buildHeaders, Util, XmStore } from 'core/services';
import { AddonRequestStatus, AddRemoveAddons, GlobalTravelPass } from './models';
import { StoreAction } from 'store/actions';
import { Injectable } from '@angular/core';

@Injectable()
export class GlobalTravelPassApi {
    public static getGlobalTravelPass(_xmStore: XmStore, http: HttpClient, _params: ApiParams): Observable<GlobalTravelPass> {
        return http.get('/xm/international', {
            headers: buildHeaders({ apiChannel: ApiChannel.SSM_GATEWAY })
        }).pipe(
            map((response: GlobalTravelPass) => GlobalTravelPass.create<GlobalTravelPass>(response))
        );
    }

    public static getGlobalTravelPassPlanEight(_xmStore: XmStore, http: HttpClient, _params: ApiParams): Observable<GlobalTravelPass> {
        return http.get('/xm/international/plan8', {
            headers: buildHeaders({ apiChannel: ApiChannel.SSM_GATEWAY })
        }).pipe(
            map((response: GlobalTravelPass) => GlobalTravelPass.create<GlobalTravelPass>(response))
        );
    }

    public static postAddRemoveAddons(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<AddRemoveAddons> {
        return http.post('/lines/plans/addons', params.payload, {
            headers: buildHeaders({ apiChannel: ApiChannel.GATEWAY })
        }).pipe(
            map((response: AddRemoveAddons) => AddRemoveAddons.create<AddRemoveAddons>(response))
        );
    }

    public static getAddonsRequestStatus(_xmStore: XmStore, http: HttpClient, params: RequestParams): Observable<AddonRequestStatus> {
        const queryParam: string = Util.createQueryParams({ requestId: params.requestId });
        
        return http.get(`/order/plans/addons/request-status${queryParam}`, {
            headers: buildHeaders({ apiChannel: ApiChannel.GATEWAY })
        }).pipe(
            map((response: ApiResponse) => AddonRequestStatus.create<AddonRequestStatus>(response))
        );
    }
}

ModelBase.fetchMapping[StoreAction.GET_GLOBAL_TRAVEL_PASS] = GlobalTravelPassApi.getGlobalTravelPass;
ModelBase.fetchMapping[StoreAction.GET_GLOBAL_TRAVEL_PASS_PLAN_EIGHT] = GlobalTravelPassApi.getGlobalTravelPassPlanEight;
ModelBase.persistMapping[StoreAction.POST_ADD_REMOVE_ADDONS] = GlobalTravelPassApi.postAddRemoveAddons;
ModelBase.fetchMapping[StoreAction.GET_ADDONS_REQUEST_STATUS] = GlobalTravelPassApi.getAddonsRequestStatus;

